/* eslint-disable no-unused-vars */
export interface TeamMember {
  id: number;
  name: string;
  email: string;
  phone_number: number;
  role: 'owner' | 'manager';
  agency_owner: boolean;
}

export interface TeamMemberRequest {
  team_member: {
    name: string;
    email: string;
    phone_number: number;
    role: 'owner' | 'manager';
    agency_role: 'owner' | 'manager';
  };
}

export enum TeamMemberRole {
  Admin = 'admin',
  Manager = 'manager'
}

export enum AgencyTeamMemberRole {
  Owner = 'owner',
  Manager = 'manager'
}
